import { createAction } from 'redux-actions';
export var setDocuments = createAction('REFUND/DOCUMENTS/SET_DOCUMENTS');
